import React, { useEffect, useState } from 'react';
import { usePlayrooms } from '../../context/PlayroomsContext';
import { Button, Carousel, Grid, Image, Spin } from 'antd';
import { EnvironmentTwoTone, PhoneTwoTone } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import Gallery from '../../components/Gallery';
import PremiumIcon from '../../icons/PremiumIcon';
import PhoneDetailsIcon from '../../icons/PhoneDetailsIcon';
import LocationDetailsIcon from '../../icons/LocationDetailsIcon';
import EmailDetailsIcon from '../../icons/EmailDetailsIcon';


const { useBreakpoint } = Grid;

export default function PlayroomDetails() {
    const { choosenPlayroom } = usePlayrooms();

    const navigate = useNavigate();

    const selectPlayroomPhotos = () => {
        let photosList = choosenPlayroom.photos.map((x) => { return x.photoUrl });
        return photosList;
    }

    const onClickReserve = () => {
        navigate("/booking-time");
    }

    useEffect(() => {
        if (choosenPlayroom == null) {
            navigate("/");
        }
    }, [choosenPlayroom, navigate]);

    if (choosenPlayroom == null) {
        return <Spin />;
    }

    return (
        <div className="min-h-screen flex flex-col"> {/* Ensure full height and consistent bg */}
            <div className="w-full flex justify-center"> {/* Center content */}
                <Gallery images={selectPlayroomPhotos()} />
            </div>

            <div className="flex flex-wrap md:flex-nowrap gap-4 px-4"> {/* Responsive layout */}
                <div className="flex md:w-1/2 w-full">
                    <div className="w-4/5 bg-cardBgGray p-2 rounded-l-[14px] lg:rounded-l-[35px] text-left md:space-y-2">
                        <h1 className='md:pl-4 pl-3 text-3xl md:text-5xl  font-bold text-footerBlue pt-2 pb-6 md:pb-8'>{choosenPlayroom.name}</h1>
                        <div className="flex items-center space-x-1 pl-2 md:pl-3"> {/* Flexbox to align icon and text horizontally */}
                            <LocationDetailsIcon />
                            <p className="text-footerBlue text-sm lg:text-xl">
                                {choosenPlayroom.location}
                            </p>
                        </div>
                        <div className="flex items-center space-x-1 pl-2 md:pl-3"> {/* Flexbox to align icon and text horizontally */}
                            <PhoneDetailsIcon />
                            <p className="text-footerBlue  text-sm lg:text-xl">
                                {choosenPlayroom.contactInfo}
                            </p>
                        </div>
                        <div className="flex items-center space-x-1 pl-2 md:pl-3"> {/* Flexbox to align icon and text horizontally */}
                            <EmailDetailsIcon />
                            <p className="text-footerBlue  text-sm lg:text-xl">
                                {choosenPlayroom.email}
                            </p>
                        </div>
                    </div>
                    <div className="w-1/5 bg-cardBgGray rounded-r-[14px] lg:rounded-r-[35px] flex items-start justify-center">
                        <div className='p-2 pr-4 md:pr-0'>
                            {choosenPlayroom.isPremium && (
                                <PremiumIcon />
                            )}
                        </div>


                    </div>

                </div>
                <div className="w-full md:w-1/2 bg-cardBgGray rounded-[14px] lg:rounded-[35px]">
                    <p className="text-footerBlue text-sm lg:text-lg text-left p-8 md:p-10">
                        {choosenPlayroom.description}
                    </p>
                </div>
            </div>
            <div className="flex w-full p-4 items-start justify-center mt-4 md:mt-8 mb-4 md:mb-8">
                <Button
                    type="submit"
                    onClick={onClickReserve}
                    className="bg-buttonYellow text-footerBlue hover:bg-footerBlue hover:text-white text-lg md:text-xl font-bold w-[500px] px-2 max-w-[350px] rounded-[50px] py-6">
                    REZERVIŠI TERMIN
                </Button>
            </div>
        </div>
    );
}
